module.exports = __webpack_public_path__ + "img/reader-icon.007501fe.svg";